module.exports = __webpack_public_path__ + "media/site/images/home_case_studies/home-case-study-ap-801425ac69032956268d712a7bd66542.png";